import React from 'react';
import PropTypes from 'prop-types';

import CutoffField from './CutoffField';

const CutoffsFieldsComponent = props =>
  <main className="flex space-between">
    {props.isLeftCutoffFieldVisible &&
      <CutoffField
        id="left-cutoff"
        name="leftCutoff"
        label="Critical Value (Left) ="
        labelClass={props.isRightCutoffFieldVisible ? 'width-70' : ''}
        onChange={props.onLeftCutoffChange}
      />
    }

    {props.isRightCutoffFieldVisible &&
      <CutoffField
        id="right-cutoff"
        name="rightCutoff"
        label="Critical Value (Right) ="
        labelClass={props.isLeftCutoffFieldVisible ? 'width-70' : ''}
        onChange={props.onRightCutoffChange}
      />
    }
  </main>;

CutoffsFieldsComponent.propTypes = {
  onLeftCutoffChange: PropTypes.func.isRequired,
  onRightCutoffChange: PropTypes.func.isRequired,

  isLeftCutoffFieldVisible: PropTypes.bool.isRequired,
  isRightCutoffFieldVisible: PropTypes.bool.isRequired
};

export default CutoffsFieldsComponent;
